//====== WR data 03/09/2026
// Motivo da alteração: porte do SmartFlow Importer do Portal LiveModa para a plataforma SmartFlow.
// View da rota /admin/smartFlowImporter/:parentId (parentId = id do SmartFlowProject) — entrada
// nova na sidebar, dentro do projeto, abaixo das listas (ver layouts/Admin.js). Carrega o projeto,
// faz login na Service Layer com as credenciais DO PROJETO (mesmo padrão do ProjectConsole) e
// renderiza o formulário (components/SmartFlow/SmartFlowImporterForm.js).
//
// WR data 15/09/2026 — SmartFlow Item Importer (Fase 3): seletor "Parceiro de Negócio" x "Item"
// antes das abas — as duas rotinas leem o MESMO conjunto de XMLs do Drive já configurado no
// projeto (login na Service Layer já feito aqui, uma vez), mas cada uma segue seu próprio
// pipeline a partir daí. O modo Parceiro continua exatamente como estava (SmartFlowImporterForm).
//======
import React from "react"
import ReactBSAlert from "react-bootstrap-sweetalert"
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import Loading from "components/Modals/Loading"
import api from "services/api"
import apiSap from "services/sapApi"
import SmartFlowImporterForm from "components/SmartFlow/SmartFlowImporterForm"
import SmartFlowItemImporterForm from "components/SmartFlow/SmartFlowItemImporterForm"
import SmartFlowPreRequisitosForm from "components/SmartFlow/SmartFlowPreRequisitosForm"
import { lerPreRequisitos } from "services/smartflow/bbpApi"
import { preRequisitosEstaoCompletos } from "components/SmartFlow/preRequisitosLogic"

const USEREMAIL_KEY = "smartflow_user_email"

class SmartFlowImporter extends React.Component {
  state = {
    loading: true,
    project: null,
    slLogado: false,
    alert: null,
    modo: "parceiro", // "prerequisitos" | "parceiro" | "item"
    // WR data 24/09/2026 — Pré-requisitos via BBP: null enquanto carrega, depois o objeto salvo
    // (ou {} se o projeto nunca preencheu). Item/Parceiro só liberam depois de confirmado.
    preRequisitos: null,
  }

  componentDidMount() {
    this.load(this.props.match.params.parentId)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.parentId !== this.state.project?._id) {
      this.load(nextProps.match.params.parentId)
    }
  }

  load = async (id) => {
    this.setState({ loading: true, slLogado: false })
    try {
      const { data: project } = await api.get("/smartflowproject/read/" + id)

      let slLogado = false
      if (project.serviceLayerUrl) {
        try {
          document.cookie = "B1SESSION=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
          const loginResp = await apiSap.post(project.serviceLayerUrl + "/Login", {
            CompanyDB: project.serviceLayerDataBase,
            UserName: project.serviceLayerUser,
            Password: project.serviceLayerPassword,
          })
          localStorage.setItem("sl_session_id", loginResp.data.SessionId)
          slLogado = true
        } catch (error) {
          localStorage.removeItem("sl_session_id")
          this.notify(
            "Não foi possível logar na Service Layer do projeto (" +
              project.serviceLayerUrl +
              "): " +
              (error?.message || "erro desconhecido") +
              ". A leitura do Drive/Receita funciona; a gravação no SAP não.",
            "warning"
          )
        }
      }

      let preRequisitos = {}
      try {
        preRequisitos = await lerPreRequisitos(id)
      } catch (error) {
        // projeto sem pré-requisitos salvos ainda não é erro — só começa vazio/bloqueado.
      }

      this.setState({
        project,
        slLogado,
        loading: false,
        preRequisitos,
        // Força a aba de Pré-requisitos quando ainda não confirmados — evita o usuário cair direto
        // em Item/Parceiro sem ter passado por ela (a trava do clique cobre a navegação manual,
        // mas o estado inicial da tela também precisa respeitar isso).
        modo: preRequisitosEstaoCompletos(preRequisitos) ? this.state.modo : "prerequisitos",
      })
    } catch (error) {
      this.notify("Não foi possível carregar o projeto.", "danger")
      this.setState({ loading: false })
    }
  }

  trocarModo = (modo) => {
    if (modo !== "prerequisitos" && !preRequisitosEstaoCompletos(this.state.preRequisitos)) {
      this.notify(
        "Confirme os Pré-requisitos (BBP) antes de importar Parceiros ou Itens — suba o BBP do projeto e valide as listas de Depósito/Grupo de Item/Grupo de PN na aba \"Pré-requisitos\".",
        "warning"
      )
      return
    }
    this.setState({ modo })
  }

  notify = (message, type = "info") => {
    const color = { success: "success", danger: "danger", warning: "warning", info: "info" }[type] || "info"
    this.setState({
      alert: (
        <ReactBSAlert
          {...(type === "success" ? { success: true } : type === "danger" ? { danger: true } : { warning: true })}
          style={{ display: "block", marginTop: "-100px" }}
          title=""
          onConfirm={() => this.setState({ alert: null })}
          onCancel={() => this.setState({ alert: null })}
          confirmBtnBsStyle={color}
          confirmBtnText="Ok"
          btnSize=""
        >
          {message}
        </ReactBSAlert>
      ),
    })
  }

  render() {
    const { loading, project, alert } = this.state
    const userEmail = localStorage.getItem(USEREMAIL_KEY) || null

    return (
      <>
        {alert}
        <SimpleHeader
          name="SmartFlow Importer"
          items={[
            { level: "nav", name: project ? project.name : "Projeto" },
            { level: "nav", name: "SmartFlow Importer" },
          ]}
        />
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              {loading || !project ? (
                <Loading modalOpened={loading} />
              ) : (
                <>
                  {(() => {
                    const completo = preRequisitosEstaoCompletos(this.state.preRequisitos)
                    return (
                      <Nav pills className="mb-3">
                        <NavItem>
                          <NavLink
                            className={classnames({ active: this.state.modo === "prerequisitos" })}
                            style={{ cursor: "pointer" }}
                            onClick={() => this.trocarModo("prerequisitos")}
                          >
                            Pré-requisitos {completo ? "✓" : "⚠"}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: this.state.modo === "parceiro",
                              "text-muted": !completo,
                            })}
                            style={{ cursor: "pointer" }}
                            onClick={() => this.trocarModo("parceiro")}
                          >
                            Parceiro de Negócio
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: this.state.modo === "item",
                              "text-muted": !completo,
                            })}
                            style={{ cursor: "pointer" }}
                            onClick={() => this.trocarModo("item")}
                          >
                            Item
                          </NavLink>
                        </NavItem>
                      </Nav>
                    )
                  })()}
                  {this.state.modo === "prerequisitos" && (
                    <SmartFlowPreRequisitosForm
                      projectId={project._id}
                      userEmail={userEmail}
                      serviceLayerUrl={project.serviceLayerUrl}
                      onValidado={(preRequisitos) => this.setState({ preRequisitos })}
                    />
                  )}
                  {this.state.modo === "item" && (
                    <SmartFlowItemImporterForm
                      project={project}
                      userEmail={userEmail}
                      onNotify={this.notify}
                    />
                  )}
                  {this.state.modo === "parceiro" && (
                    <SmartFlowImporterForm
                      project={project}
                      userEmail={userEmail}
                      onNotify={this.notify}
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

export default SmartFlowImporter
